exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu__content{margin-top:25px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/header/PlatformActions.vue
// module id = 1093
// module chunks = 22